// v1 overview
import { Overview as V1Overview } from './Overview';

/**
 * Project overview route adapter.
 *
 * Renders the legacy v1 `Overview` for both classic and v2 (FundsChain 2.0)
 * projects. The v2 "Planning Summary" view lives under the spend-plans subtree
 * inside the Activity Planning group.
 */
export const ProjectOverviewRoute = () => {
	return <V1Overview />;
};
